import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutMe.css';

const AboutMe: React.FC = () => {
  useEffect(() => {
    document.title = 'About Me | Sourov Roy';
  }, []);

  return (
    <div className="about-me">
      <div className="about-me-container">
        <div className="about-me-content">
          <div className="about-me-text">
            <h1 className="about-me-title">About Me</h1>
            <div className="about-me-bio">
              <p>
                Hello, I'm Sourov Roy, a Senior Software Engineer with six years of experience designing and building scalable distributed systems at <a href="https://en.wikipedia.org/wiki/Amazon_(company)" target="_blank" rel="noopener noreferrer">Amazon</a>, <a href="https://en.wikipedia.org/wiki/Deliveroo" target="_blank" rel="noopener noreferrer">Deliveroo</a>, <a href="https://en.wikipedia.org/wiki/DoorDash" target="_blank" rel="noopener noreferrer">DoorDash</a>, and <a href="https://en.wikipedia.org/wiki/Salesforce" target="_blank" rel="noopener noreferrer">Salesforce</a>.
              </p>
              <p>
                I graduated in <strong>Computer Science & Engineering</strong> from <a href="https://en.wikipedia.org/wiki/Jadavpur_University" target="_blank" rel="noopener noreferrer">Jadavpur University</a> in 2020.
              </p>
              <p>
                I’m deeply passionate about distributed systems, cloud computing and artificial intelligence, with a strong foundation in algorithms, system design, and large-scale architecture. I enjoy solving complex engineering challenges that make technology more reliable, scalable, and efficient, ultimately impacting millions of users worldwide.
              </p>
              <p>
                Outside of work, I enjoy reading and writing about nature, technology, history, finance, and music. 
                Feel free to explore my <Link to="/blog" className="blog-link">blogs</Link> to learn more about my interests and ideas, 
                and don't hesitate to reach out to me on <a href="https://www.linkedin.com/in/sourovroy-ai/" target="_blank" rel="noopener noreferrer" className="linkedin-link">LinkedIn</a> if you'd like to connect.
              </p>
            </div>
            
            <div className="about-me-highlights">
              <div className="highlight-item">
                <h3>Current Role</h3>
                <p>Software Engineer 2 at Amazon</p>
              </div>
              <div className="highlight-item">
                <h3>Experience</h3>
                <p>6+ years in software engineering</p>
              </div>
              <div className="highlight-item">
                <h3>Mentoring</h3>
                <p>8+ years in mentoring</p>
              </div>
              <div className="highlight-item">
                <h3>Education</h3>
                <p>BE in Computer Science & Engineering from <a href="https://en.wikipedia.org/wiki/Jadavpur_University" target="_blank" rel="noopener noreferrer">Jadavpur University</a></p>
              </div>
              <div className="highlight-item">
                <h3>Location</h3>
                <p>Bangalore, India</p>
              </div>
            </div>

            <div className="about-me-skills">
              <h3>Key Expertise</h3>
              <div className="skills-tags">
                <span className="skill-tag">Distributed Systems</span>
                <span className="skill-tag">AWS</span>
                <span className="skill-tag">Java</span>
                <span className="skill-tag">Golang</span>
                <span className="skill-tag">Python</span>
                <span className="skill-tag">React</span>
                <span className="skill-tag">Artificial Intelligence</span>
              </div>
            </div>
          </div>
          
          <div className="about-me-image">
            <img src="https://s3.ap-south-1.amazonaws.com/sourovroy.me-content/personal/images/me.jpeg" alt="Sourov Roy" className="profile-image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
